module.exports = __webpack_public_path__ + "img/ionicons.17bf2ac0.svg";